import Cookies from '@root/vendor/js-cookie';
import PropTypes from '@root/vendor/prop-types';
import React, { useCallback } from '@root/vendor/react';
import URI from '@root/vendor/uri';
import environment from '@root/core/src/utils/environment';
import uuid from '@root/vendor/uuid/v4';

const rootIdCookieName = `__r.root_id_${environment.environment}`;
const RootIdStateContext = React.createContext();

function RootIdProvider({ children }) {
  const setrootIdCookie = useCallback((rootId) => {
    if (typeof window !== 'undefined') {
      Cookies.set(rootIdCookieName, rootId, {
        path: '/',
        expires: 365,
        domain: new URI(window.location).domain(), /* eslint root/prevent-use-of-window-location: 0 */
      });
    }
  }, []);

  const getrootId = useCallback(() => {
    let rootId = Cookies.get(rootIdCookieName);

    if (!rootId) {
      rootId = uuid();
      setrootIdCookie(rootId);
    }

    return rootId;
  }, [setrootIdCookie]);

  return (
    <RootIdStateContext.Provider value={getrootId()}>
      {children}
    </RootIdStateContext.Provider>
  );
}

RootIdProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

function useRootId() {
  const context = React.useContext(RootIdStateContext);
  if (context === undefined) {
    throw new Error('userootIdState must be used within a rootIdProvider');
  }
  return context;
}

function withRootId(WrappedComponent) {
  const WithRootId = (props) => {
    return (
      <WrappedComponent
        rootId={useRootId()}
        {...props}
      />
    );
  };

  return WithRootId;
}

export { RootIdProvider, useRootId, withRootId };
